import { ReactElement } from "react";
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// components
import { BannerSection } from "./components/Banner_StrgyDev";
import ImgWorkProcess from "@imgs/img-work-process.jpg";


const SvcStrgyDevPage = (): ReactElement => {

  return (
    <>
      <BannerSection />
      <Container sx={{ my: 1, p: 5, maxWidth: "1170px", }}>
        <Grid container spacing={2} sx={{ mx: 'auto', justifyContent: "center", maxWidth: '860px', minHeight: '500px' }}>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '32px', fontWeight: 800, color: '#3F51B5', }}>分析の流れ</Typography>
          </Grid>
          <Grid sm={6} xs={12}>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgWorkProcess}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SvcStrgyDevPage;
